{
  "Thank you for filling in the form.": "Tak, fordi du udfyldte formularen.",
  "There was an error in your submission, please try again in a few seconds. If the issue persists, please contact us.": "Der opstod en fejl i din indsendelse, prøv igen om et par sekunder. Hvis problemet fortsætter, bedes du kontakte os."
}
